// Canonical public pages and published blog slugs. Unknown/admin routes are excluded.
export const MEASUREMENT_PATHS = new Set([
  "/",
  "/about",
  "/afraid-of-dental-work-sedation",
  "/all-on-4-guide",
  "/all-on-4-new-port-richey-fl",
  "/all-on-4-trinity-fl",
  "/all-on-4-vs-all-on-6",
  "/all-on-4-vs-dentures",
  "/all-on-x",
  "/best-implant-dentist-trinity-fl",
  "/blog",
  "/blog/all-on-4-dental-implants-explained",
  "/blog/dental-implants-near-me-trinity-fl",
  "/blog/full-mouth-dental-implants-options",
  "/blog/implant-dentures-snap-in-vs-fixed",
  "/blog/same-day-dental-implants-candidates",
  "/blog/teeth-in-a-day-how-it-works",
  "/blog/what-are-dental-implants",
  "/blog/what-is-an-implant-dentist",
  "/bone-grafting",
  "/book-appointment",
  "/brooksville-fl",
  "/cant-chew-missing-teeth",
  "/clearwater-fl",
  "/consult",
  "/contact-us",
  "/cosmetic-dentist-tampa-fl",
  "/cosmetic-dentist-trinity-fl",
  "/cosmetic-dentistry",
  "/cosmetic-dentistry-guide",
  "/dental-assessment",
  "/dental-bridges",
  "/dental-implant-cost",
  "/dental-implant-cost-florida",
  "/dental-implants",
  "/dental-implants-faq",
  "/dental-implants-guide",
  "/dental-implants-near-trinity-college-fl",
  "/dental-implants-near-trinity-commons-fl",
  "/dental-implants-new-port-richey-fl",
  "/dental-implants-questions",
  "/dental-implants-trinity-east-fl",
  "/dental-implants-trinity-fl",
  "/dental-implants-trinity-preserve-fl",
  "/dental-implants-trinity-west-fl",
  "/dental-implants-vs-dentures",
  "/dentist-seven-springs-fl",
  "/dentures",
  "/do-dental-implants-hurt",
  "/does-medicare-cover-dental-implants",
  "/dunedin-fl",
  "/emergency-dentist-clearwater-fl",
  "/emergency-dentist-new-port-richey-fl",
  "/emergency-dentist-trinity-fl",
  "/emergency-dentistry",
  "/family-dentist-trinity-fl",
  "/faq",
  "/financing-options",
  "/fixed-new-teeth",
  "/fixed-vs-removable-implant-teeth",
  "/full-mouth-restoration",
  "/general-dentistry",
  "/holiday-fl",
  "/how-to-choose-a-dentist-in-trinity-fl",
  "/hudson-fl",
  "/implant-research-data",
  "/in-house-lab",
  "/invisalign",
  "/invisalign-new-port-richey-fl",
  "/invisalign-trinity-fl",
  "/keystone-fl",
  "/land-o-lakes-fl",
  "/laser-dentistry",
  "/loose-dentures-trinity-fl",
  "/lutz-fl",
  "/meet-the-doctor",
  "/mini-dental-implants",
  "/new-port-richey-fl",
  "/odessa-fl",
  "/oldsmar-fl",
  "/oral-surgery",
  "/our-results",
  "/our-technology",
  "/palm-harbor-fl",
  "/patient-education",
  "/patient-reviews",
  "/periodontal-disease-treatment",
  "/port-richey-fl",
  "/preventative-dentistry",
  "/regenerative-dentistry",
  "/resources",
  "/resources/dental-insurance",
  "/same-day-crowns",
  "/same-day-dental-implants-trinity-fl",
  "/sedation-dentistry",
  "/services",
  "/single-implant",
  "/sinus-grafts",
  "/sleep-apnea-treatment",
  "/smile-visualizer",
  "/snap-in-dentures",
  "/spring-hill-fl",
  "/st-petersburg-fl",
  "/tampa-fl",
  "/tarpon-springs-fl",
  "/teeth-whitening-trinity-fl",
  "/tmj-treatment",
  "/too-old-for-dental-implants",
  "/tooth-extractions",
  "/trinity-fl",
  "/veneers-palm-harbor-fl",
  "/veneers-trinity-fl",
  "/wesley-chapel-fl",
  "/westchase-fl",
  "/zephyrhills-fl"
]);

export const BLOG_POSTS = new Set([
  "can-veneers-fix-crooked-teeth",
  "dental-sedation-calm-confident-treatment",
  "all-on-4-dental-implants-cost",
  "all-on-4-vs-all-on-6",
  "all-on-x-comparison",
  "all-on-x-treatment-review",
  "all-on-x-vs-dentures",
  "are-dental-implants-worth-it",
  "are-implant-supported-teeth-permanent",
  "best-cosmetic-dental-procedures",
  "best-dentist-for-dental-implants",
  "best-foods-after-implant-surgery",
  "best-options-for-missing-teeth",
  "best-smile-makeover-treatments",
  "best-tooth-replacement-options",
  "bone-grafting-before-dental-implants",
  "can-implants-prevent-bone-loss",
  "can-invisalign-fix-bite-issues",
  "can-one-implant-replace-two-teeth",
  "can-you-get-implants-with-bone-loss",
  "choose-cosmetic-dentist-trinity-fl",
  "dental-bone-graft-guide",
  "dental-implant-recovery-guide",
  "dental-implants-stronger-complete-smile",
  "dental-implants-trinity-patients-can-trust",
  "dental-implants-vs-bridges",
  "dentist-for-dental-anxiety",
  "do-veneers-stain-over-time",
  "emergency-dentist-for-broken-tooth",
  "emergency-dentist-trinity-when-to-act-fast",
  "emergency-dentist-wesley-chapel",
  "emergency-dentistry",
  "emergency-tooth-extraction-trinity",
  "examples-of-cosmetic-dentistry",
  "fixed-new-teeth-review",
  "fixed-teeth-in-a-day-what-to-expect",
  "full-arch-implant-guide",
  "full-arch-implant-transformation-example",
  "full-mouth-dental-implants-clearwater",
  "full-mouth-restoration-guide",
  "how-all-on-4-works",
  "how-dental-implants-work",
  "how-does-invisalign-work",
  "how-full-mouth-restoration-works",
  "how-implant-sedation-works",
  "how-invisalign-moves-teeth",
  "how-long-do-dental-implants-last",
  "how-many-veneers-do-i-need",
  "how-same-day-crowns-work",
  "how-smile-makeover-planning-works",
  "how-to-choose-cosmetic-dentist",
  "how-to-choose-same-day-crowns-near-me",
  "how-to-clean-implant-dentures",
  "how-to-finance-dental-implants",
  "how-to-handle-knocked-out-tooth",
  "how-to-prepare-for-dental-implants",
  "how-to-treat-gum-recession",
  "implant-consultation-checklist",
  "implant-dentist",
  "implant-dentist-trinity-fl",
  "implant-financing-in-trinity",
  "implant-specialist",
  "implant-supported-dentures-odessa",
  "invisalign-dentist-wesley-chapel",
  "invisalign-vs-braces-for-adults",
  "is-cosmetic-dentistry-expensive",
  "is-invisalign-worth-it-adults",
  "multiple-implant-restoration-case",
  "oral-sedation-vs-iv-sedation",
  "reduce-dental-anxiety-before-treatment",
  "replace-failing-dental-work",
  "replace-missing-teeth-options",
  "sedation-dentist-new-port-richey",
  "sedation-dentistry-for-anxious-patients",
  "sinus-grafting-dental-implants",
  "smile-makeover-before-and-after",
  "smile-makeover-financing-options",
  "smile-makeover-wesley-chapel",
  "tooth-pain-relief-clearwater",
  "veneers-vs-bonding-for-front-teeth",
  "veneers-vs-crowns-difference",
  "what-is-a-sinus-lift-for-implants",
  "what-is-laser-dentistry-used-for",
  "what-to-do-for-severe-tooth-pain",
  "when-do-you-need-full-mouth-reconstruction",
  "who-is-a-candidate-for-all-on-x"
]);

// Refresh the fallback list from the site's own published sitemap. Only canonical,
// same-origin public paths and well-formed article slugs may enter the allowlist.
export function registerPublishedMeasurementUrls(values) {
  let added = 0;
  for (const value of values) {
    try {
      const url = new URL(value);
      if (url.origin !== 'https://trinitydentalarts.com' || url.hash ||
          !/^\/[a-z0-9/-]*$/i.test(url.pathname)) continue;
      if (url.pathname === '/blog' && url.searchParams.has('post')) {
        const post = url.searchParams.get('post');
        if ([...url.searchParams.keys()].some(key => key !== 'post') ||
            !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(post || '') || post.length > 160) continue;
        if (!BLOG_POSTS.has(post)) { BLOG_POSTS.add(post); added++; }
      } else if (!url.search) {
        const path = url.pathname.replace(/\/$/, '') || '/';
        if (!MEASUREMENT_PATHS.has(path)) { MEASUREMENT_PATHS.add(path); added++; }
      }
    } catch { /* Ignore malformed sitemap entries. */ }
  }
  return added;
}

let refreshing;
let refreshedAt = 0;
export function refreshMeasurementPaths() {
  if (typeof window === 'undefined' || window.location.origin !== 'https://trinitydentalarts.com') return Promise.resolve();
  if (refreshing) return refreshing;
  if (Date.now() - refreshedAt < 300000) return Promise.resolve();
  refreshedAt = Date.now();
  refreshing = fetch('/sitemap.xml', { credentials: 'omit', signal: AbortSignal.timeout(8000) })
    .then(response => { if (!response.ok) throw new Error('Sitemap unavailable'); return response.text(); })
    .then(xml => {
      const doc = new DOMParser().parseFromString(xml, 'application/xml');
      if (doc.querySelector('parsererror')) return;
      registerPublishedMeasurementUrls([...doc.getElementsByTagName('loc')].map(node => node.textContent.trim()));
    })
    .catch(() => { /* Keep the vetted build-time fallback when the sitemap is unavailable. */ })
    .finally(() => { refreshing = undefined; });
  return refreshing;
}

